import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  max-width: 100%;
  margin: 0;
`;

export const FormSection = styled.div`
  background: ${({ theme }) => theme.palette[10]};
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 20px;
  border: 1px solid ${({ theme }) => theme.palette[100]};
`;

export const FormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

export const FormColumn = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  margin-top: 30px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const UpgradeSummary = styled.div`
  background: ${({ theme }) => theme.palette[20]};
  border: 1px solid ${({ theme }) => theme.palette[200]};
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid ${({ theme }) => theme.palette[100]};
  
  &:last-child {
    border-bottom: none;
  }
`;

export const SummaryLabel = styled.span`
  font-weight: 500;
  color: ${({ theme }) => theme.palette[700]};
  flex: 1;
`;

export const SummaryValue = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.palette[900]};
  text-align: right;
`;

export const TotalRow = styled(SummaryRow)`
  border-top: 2px solid ${({ theme }) => theme.palette[300]};
  margin-top: 10px;
  padding-top: 15px;
  
  ${SummaryLabel}, ${SummaryValue} {
    font-weight: 700;
    font-size: 1.1em;
    color: ${({ theme }) => theme.palette[900]};
  }
`;




